export const ROWS_PER_PAGE = 100;

export const SELECTION_COLUMN_WIDTH = 49;
export const ROW_HEIGHT = 40;

export const URL_COLUMN_ID = "landingPage";
export const URL_COLUMN_TITLE = "URL";
export const URL_COLUMN_DEFAULT_WIDTH = 450;

export const NAME_COLUMN_ID = "name";
export const NAME_COLUMN_TITLE = "Name";
export const NAME_COLUMN_DEFAULT_WIDTH = 450;

export const isColumnSortable = (name: string) => {
  return true;
};

export const isColumnFilterable = (metricName: string) => {
  if ([URL_COLUMN_ID, NAME_COLUMN_ID].includes(metricName)) {
    return false;
  }

  return true;
};
